import React, { useEffect } from "react"
import { useCookies } from "react-cookie"
import { useRecoilValue } from "recoil"
import styled from "styled-components"
import { isLoggedInState } from "../../../recoil/auth/atom"
import { useGetUserinfo } from "../../../hooks/useGetUserinfo"

const Profile = () => {
  const isLoggedIn = useRecoilValue(isLoggedInState)
  const [cookie] = useCookies(["email"])
  const {
    isLoading,
    data: userinfo,
    refetch: getUserinfo,
  } = useGetUserinfo(cookie.email)

  useEffect(() => {
    console.log("지훈요청: api연결: 마이페이지 user profile 이미지 받아오기")
    console.log(
      "지훈요청: api연결: 사용자 정보 수정하는 페이지 -> 페이지 들어가면 회원탈퇴도 가능하도록"
    )
    if (isLoggedIn) {
      getUserinfo()
    }
  }, [getUserinfo, isLoggedIn])

  useEffect(() => {
    console.log(userinfo)
  }, [userinfo])

  return (
    <Container>
      <ContainerInner>
        <Avatar src="https://t4.ftcdn.net/jpg/05/67/65/65/360_F_567656574_Xd7SLrExQIyBP2RtGNjX4YktRkat1jtF.jpg" />
        <InfoWrapper>
          <Name>
            {isLoading ? "" : userinfo?.last_name + userinfo?.first_name}
          </Name>
          <Desc>{isLoading ? "" : userinfo?.school}</Desc>
        </InfoWrapper>
      </ContainerInner>
    </Container>
  )
}

export default Profile

const Container = styled.div`
  width: 100%;
  background-color: #4f67ed;
  position: relative;
`

const ContainerInner = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 50px 80px;
  max-width: 1280px;
  margin: 0 auto;
`

const Avatar = styled.img`
  width: 160px;
  height: 160px;
  border-radius: 100px;
  background-color: #888;
  background-repeat: no-repeat;
  background-size: cover;
`

const InfoWrapper = styled.div`
  display: inline-block;
  color: #ffffff;
`

const Name = styled.div`
  font-size: 30px;
`

const Desc = styled.div`
  font-size: 22px;
`
